import DashboardInicial from '../../spa/dashboard-inicial/DashboardInicial';

export default {
  path: 'dashboard-inicial',
  name: 'dashboard-inicial',
  component: DashboardInicial,
};
